import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { venturesBeingBuilt } from '../../mock';

export default function VenturesBeingBuilt() {
  return (
    <section id="ventures" className="relative bg-[#08080a] py-20 lg:py-28 border-t border-white/5 overflow-hidden">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-[#d42b92]/10 blur-[180px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="reveal-up grid lg:grid-cols-12 gap-8 lg:gap-14 items-start">
          <div className="lg:col-span-5">
            {/* <div className="text-[#ff8ec5] text-[11px] font-medium tracking-[0.28em] uppercase shrink-0">
              Innov Ventures
            </div> */}
            <h2 className="font-semibold tracking-tight text-white text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] leading-[1.05]">
              From possibility to <span className="text-[#d42b92]">enterprise</span>.
            </h2>
            <p className="mt-6 text-white/80 text-lg sm:text-xl leading-relaxed font-medium italic">
              InnovVentures is the venture studio arm, where opportunities are identified, concepts
              are shaped and new businesses are built.
            </p>
          </div>

          <div className="lg:col-span-7 space-y-5 text-white/60 text-[15px] sm:text-lg leading-relaxed">
            <p>
              The studio works hands-on across venture strategy, product development, business
              models, market validation, partnerships, technology and go-to-market, bringing
              together the capabilities required to move an idea towards an investable and scalable
              enterprise.
            </p>
            <p>
              Some ventures originate within the InnovHer ecosystem; others are built alongside
              founders, institutions and strategic partners.
            </p>
            <p>
              The approach goes beyond advising businesses from the outside. InnovVentures participates in the building journey, creating, validating and strengthening ventures from within.
            </p>
          </div>
        </div>

        <div className="reveal-up mt-14 lg:mt-16 mb-6 flex items-center gap-4">
          <div className="text-[#ff8ec5] text-[11px] font-medium tracking-[0.28em] uppercase shrink-0">
            InnovVentures Ongoing builds
          </div>
          {/* <div className="h-px flex-1 bg-white/10" /> */}
        </div>

        <div className="reveal-up grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {venturesBeingBuilt.map((v) => (
            <Link
              key={v.slug}
              to={`/ventures/${v.slug}`}
              className="group flex flex-col rounded-2xl border border-white/10 bg-white/[0.02] p-4 hover:border-white/25 hover:bg-white/[0.05] transition-all duration-300"
            >
              <div className="h-20 w-full rounded-xl bg-white/95 flex items-center justify-center p-3 group-hover:bg-white transition-colors">
                <img
                  src={v.logo}
                  alt={v.name}
                  className="max-h-9 w-auto max-w-[85%] object-contain"
                />
              </div>
              <div className="mt-3.5 flex items-center justify-between px-1">
                <span className="font-semibold text-base text-white group-hover:text-[#ff8ec5] transition-colors">
                  {v.name}
                </span>
                <ArrowUpRight className="w-4 h-4 text-white/40 group-hover:text-[#ff8ec5] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
